const shuffleCards = (cards) => [...cards].sort(() => Math.random() - 0.5);

const getMissedCards = (flashcards) => {
  return flashcards.filter(card =>
    (card.incorrectCount || 0) > 0 &&
    ((card.incorrectCount || 0) >= (card.correctCount || 0) || card.lastAnsweredCorrect === false)
  );
};

export const getCardsForStudyMode = (flashcards, studyMode = 'random') => {
  if (studyMode === 'missed') {
    return getMissedCards(flashcards);
  }

  return flashcards;
};

export const getNextBatchOfCards = (flashcards, previousBatch = [], batchSize = 10, studyMode = 'random') => {
  if (flashcards.length === 0) return [];

  if (studyMode === 'sequential') {
    return flashcards.slice(0, batchSize);
  }

  if (studyMode === 'missed') {
    const missedCards = getMissedCards(flashcards);
    if (missedCards.length > 0) {
      return shuffleCards(missedCards).slice(0, batchSize);
    }
    return [];
  }

  const allReviewed = flashcards.every(card => card.reviewed);
  if (allReviewed) {
    return shuffleCards(flashcards).slice(0, batchSize);
  }

  let availableCards = flashcards.filter(card => 
    !card.reviewed && !previousBatch.some(prevCard => prevCard.id === card.id)
  );

  if (availableCards.length === 0) {
    availableCards = flashcards.filter(card => 
      !previousBatch.some(prevCard => prevCard.id === card.id)
    );
  }

  if (availableCards.length === 0 && previousBatch.length > 0) {
    availableCards = flashcards;
  }

  if (availableCards.length === 0) {
    availableCards = flashcards;
  }

  return shuffleCards(availableCards).slice(0, batchSize);
};
